<template>
  <Icon>
    <svg slot="svg" width="45px" height="47px" viewBox="0 0 45 47" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="comps/error-comp" transform="translate(-348.000000, -29.000000)">
          <g id="Group" transform="translate(208.000000, 26.000000)">
            <g id="icons/disconnect" transform="translate(134.000000, 0.000000)">
              <rect id="Bounding-Box" x="0" y="0" width="54" height="54"></rect>
              <g id="Icons8-Gps-Disconnected" stroke-width="1" fill-rule="evenodd" transform="translate(6.750000, 4.500000)">
                <g id="Group" transform="translate(2.442857, 8.750000)" fill="#64B5F6" fill-rule="nonzero">
                  <polygon id="Shape" points="13.4442643 32.5 9.77753571 27.57375 3.66672857 25 3.55271368e-15 32.42625 3.55271368e-15 36.25 13.4442643 36.25"></polygon>
                  <path d="M28.65105,28.9625 C31.0365,26.52125 26.7810429,18.21125 19.14345,10.4 C11.5070786,2.59 3.38091429,-1.7625 0.995464286,0.6775 C-1.38998571,3.1175 2.86425,11.43 10.5018429,19.24125 C18.1382143,27.05125 26.2656,31.40125 28.65105,28.9625 Z" id="Shape"></path>
                </g>
                <path d="M5.77125,34.43625 L4.60234286,36.8025 C7.51056429,39.715 11.5962429,41.89 15.8871214,42.96625 L15.8871214,41.25 L15.0773143,40.16125 C11.6573143,39.08 8.46572143,37.235 6.18409286,34.9025 C6.04118571,34.75625 5.91049286,34.59 5.77125,34.43625 Z" id="Shape" fill="#1E88E5" fill-rule="nonzero"></path>
                <g id="Group" stroke-linecap="round" transform="translate(32.978571, 0.000000)" stroke="#FF3D00" stroke-width="2.5">
                  <path d="M9.77142857,0 L1.13592857,8.8375" id="Shape"></path>
                  <path d="M1.13592857,0 L9.77142857,8.8375" id="Shape"></path>
                </g>
                <path d="M12.9447,27.99125 C5.31443571,20.1875 1.06142143,11.885 3.43221429,9.43625 C-2.66882143,15.685 0.0586285714,28.63875 6.18409286,34.90375 C12.312,41.17125 24.9855429,43.96125 31.0939071,37.71375 C28.7084571,40.15125 20.5810714,35.80125 12.9447,27.99125 Z" id="Shape" fill="#BBDEFB" fill-rule="nonzero"></path>
                <path d="M7.31513571,21.3275 L21.4067571,19.4475 L19.5721714,33.83125 C20.3441143,34.4075 21.1001786,34.935 21.8367,35.41125 L23.6297571,21.35375 C22.9762929,20.61875 22.3008429,19.8825 21.5863071,19.15125 C20.9120786,18.46 20.2329643,17.80875 19.5550714,17.175 L5.76025714,19.015 C6.22928571,19.76625 6.74961429,20.54 7.31513571,21.3275 Z" id="Shape" fill="#546E7A" fill-rule="nonzero"></path>
                <path d="M25.7981593,14.848375 C27.2291484,16.3128375 27.2291484,18.6872125 25.7981593,20.151675 C24.3671702,21.6161375 22.0470666,21.6161375 20.6160776,20.151675 C19.1850885,18.6872125 19.1850885,16.3128375 20.6160776,14.848375 C22.0470666,13.3839125 24.3671702,13.3839125 25.7981593,14.848375" id="Shape" fill="#0D47A1" fill-rule="nonzero"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsFetchingErrorIcon",
  components: {
    Icon
  },
  extends: Icon
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-fetching-error-icon.vue